<template>
  <div>
    <div class="gacha-container">
      <div class="top-bar">
        <div class="left-empty">
          <el-button type="warning" @click="onMyGacha" plain>
            <i class="el-icon-reading"></i> {{ $t('gacha.myCollection') }}
          </el-button>
        </div>
        <h2 class="title">{{ $t('gacha.luckyGacha') }}</h2>
        <div class="right-empty"></div>
      </div>
      <!-- Loading 遮罩弹窗 -->
      <div v-if="loading" class="loading-mask">
        <div class="loading-box">{{ $t('gacha.loadingTip') }}</div>
      </div>
      <div v-else>
        <el-button-group v-for="item in titles" :key="item" style="padding: 10px;">
          <el-button v-if="studying==1 && item.status==1" class="card-rate card-tag" round :class="`tag-${item.id}`" @click="goGetCards(item)">{{ item.enName }}</el-button>
          <el-button v-if="studying==0 && item.status==1" class="card-rate card-tag" round :class="`tag-${item.id}`" @click="goGetCards(item)">{{ item.name }}</el-button>
        </el-button-group>
        <el-empty v-if="total==0" :image-size="100">
          <div class="card-name" >{{ $t('gacha.saleTime') }}：{{ empty.startTime | formatDateTime}}-{{ empty.endTime | formatDateTime}}</div>
        </el-empty>
        <div class="grid-box limit-eight">
          <div
              class="card-item"
              v-for="(item) in cardList15"
              :class="getCardClass(item)"
              :key="item.id"
          >
            <img class="card-img" :src="item.backImage" alt="" />
          </div>
        </div>
      </div>
      <!-- 悬浮抽卡按钮 固定屏幕正中 -->
      <div class="float-lottery-wrapper">
        <button
            class="table-button"
            :disabled="rolling"
            @click="startLottery"
        >
          {{ rolling ? $t('gacha.gachaRunning') : $t('gacha.startGacha') }}
        </button>
        <span class="chance-text">{{ $t('gacha.remainChance', {num: userCardsRoleNum}) }}</span>
      </div>
      <!-- 获奖弹窗 - 无边框透明版 + X关闭 + titleId對應發光邊框 -->
      <div class="modal-mask no-border-modal" v-show="showModal" @click="showModal=false;unlockBodyScroll()">
        <div class="modal-content" @click.stop>
          <!-- 关闭X -->
          <div class="close-x" @click="showModal=false;unlockBodyScroll()">×</div>
          <!-- 外層容器做發光光暈，動態綁定 glow‑${gotCard.titleId} -->
          <div class="win-img-wrap" :class="`glow-${gotCard.titleId}`">
            <img :src="gotCard.image" class="win-img no-border-img"/>
          </div>
          <div class="win-text">{{ $t('gacha.congratsGet') }}：{{gotCard.name}}</div>
          <div class="card-tag" :class="`tag-${gotCard.propertyId}`">{{ gotCard.propertyName }}</div>
          <div class="card-tag" :class="`tag-${gotCard.propertyId}`">{{ studying==0?gotCard.titleName:gotCard.titleEnName }}</div>
          <div style="color:#fff;margin-top:10px;">{{ gotCard.content }}</div>
          <el-button type="warning" @click="onMyGacha" size="mini" plain style="margin-top:10px;">
            <i class="el-icon-reading"></i> {{ $t('gacha.myCollection') }}
          </el-button>
        </div>
      </div>
      <!-- 无机会弹窗 -->
      <div
          class="modal-mask"
          v-show="notRoleShowModal"
          @click="notRoleShowModal = false;unlockBodyScroll()"
      >
        <div v-if="total > 0" class="modal-content" @click.stop>
          <div class="win-title">{{ $t('gacha.tip') }}</div>
          <div class="win-text">{{ $t('gacha.noChanceNow') }}</div>
          <div class="win-sub-title">{{ $t('gacha.howGetChance') }}：</div>
          <div class="win-desc">
            {{ $t('gacha.chanceRule') }}
          </div>
          <el-button class="confirm-btn" size="small" @click="notRoleShowModal = false;unlockBodyScroll()">
            {{ $t('gacha.gotIt') }}
          </el-button>
        </div>
        <div v-if="total==0" class="modal-content" @click.stop>
          <div class="win-title">{{ $t('gacha.tip') }}</div>
          <div class="win-text">{{ $t('gacha.noCardAvailable') }}</div>
          <el-button class="confirm-btn" size="small" @click="notRoleShowModal = false;unlockBodyScroll()">
            {{ $t('gacha.gotIt') }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCards,getCardTitleList, getUserCardsRoleNum,saveCardsUser } from "@/api/cards";
import {getStudying} from "@/api/user";
export default {
  data() {
    return {
      loading: true,
      userCardsRoleNum: 0,
      activeIndex: -1,
      titleId: null,
      titles: [],
      rolling: false,
      timer: null,
      showModal: false,
      notRoleShowModal: false,
      winName: '',
      winImage: '',
      gotCard:{},
      cardList: [],
      cardList15: [],
      runOrder: [0, 1, 2],
      audioStart: null,
      audioRoll: null,
      audioWin: null,
      backImage: "require('@/assets/images/kaback.png')",
      total: 0,
      studying:0,
      empty: {},
      listQ: {
        _page1: 1,
        _page2: 1,
        _limit: 100,
      },
      cardsUser: {
        userId: null,
        cardId: null,
      },
    };
  },
  mounted() {
    this.audioStart = new Audio(require('@/assets/vedio/roll.mp3'));
  },
  created() {
    this.getStudying();
    this.getUserCardsRoleNum();
    this.indexTitle();
    this.getCards();
  },
  filters: {
    formatDateTime(time) {
      let timeStr = ''
      if(time && typeof time === 'object' && time.date){
        timeStr = time.date
      }else{
        timeStr = time
      }
      if (!timeStr) return "-";
      const d = new Date(timeStr);
      if (isNaN(d.getTime())) return "-";
      const year = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${m}-${day}`;
    }
  },
  computed:{
    getStatusText(){
      return (v)=>{
        return v === 0 ? this.$t('gacha.status.offline') : this.$t('gacha.status.online')
      }
    }
  },
  methods: {
    lockBodyScroll() {
      document.documentElement.classList.add('modal-open');
      document.body.classList.add('modal-open');
    },
    unlockBodyScroll() {
      document.documentElement.classList.remove('modal-open');
      document.body.classList.remove('modal-open');
    },
    async getStudying() {
      const v = await getStudying();
      this.studying = v.data;
    },
    getCardClass(item) {
      const classes = [];
      const propertyId = item.propertyId;
      if (propertyId === 1) classes.push('rarity-1');
      else if (propertyId === 2) classes.push('rarity-2');
      else if (propertyId === 3) classes.push('rarity-3');
      else if (propertyId === 4) classes.push('rarity-4');
      else if (propertyId === 5) classes.push('rarity-5');
      else classes.push('rarity-default');
      if (this.activeIndex === this.cardList.indexOf(item)) {
        classes.push('active');
      }
      return classes;
    },
    goGetCards(row) {
      this.titleId = row.id;
      this.backImage = row.image;
      this.empty = row;
      this.getCards();
    },
    getCards() {
      let form = {
        titleId: this.titleId,
        _page: this.listQ._page2 - 1,
        _limit: this.listQ._limit,
      };
      getCards(form).then((v) => {
        this.cardList = v.data;
        // 截取前15条
        this.cardList15 = this.cardList.slice(0, 15);
        this.total = Number(v.headers["x-total-count"]);
        this.loading = false;
      });
    },
    indexTitle() {
      getCardTitleList().then((v) => {
        this.titles = v.data;
      });
    },
    async getUserCardsRoleNum() {
      const res = await getUserCardsRoleNum();
      this.userCardsRoleNum = res.data;
    },
    saveCardsUser() {
      saveCardsUser(this.cardsUser);
    },
    onMyGacha() {
      const newPath = "/myGacha";
      if (this.$route.path !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    playSound(type) {
      if (type === 'start') {
        this.audioStart.currentTime = 0;
        this.audioStart.play();
      }
      if (type === 'win') {
        this.audioStart.pause();
        this.audioStart.currentTime = 0;
      }
    },
    getRandomCard2() {
      let random = Math.random() * 100;
      let total = 0;
      for (let i = 0; i < this.cardList.length; i++) {
        total += parseFloat(this.cardList[i].probability);
        if (random < total) {
          return i;
        }
      }
      return 0;
    },
    getRandomCard() {
      const list = this.cardList;
      let totalWeight = 0;
      list.forEach(item => {
        totalWeight += Number(item.probability || 0);
      });
      if (totalWeight <= 0) {
        return Math.floor(Math.random() * list.length);
      }
      const randomVal = Math.random() * totalWeight;
      let accumulate = 0;
      for (let i = 0; i < list.length; i++) {
        const w = Number(list[i].probability);
        accumulate += w;
        if (randomVal < accumulate) {
          return i;
        }
      }
      return Math.floor(Math.random() * list.length);
    },
    async startLottery() {
      await this.getUserCardsRoleNum();
      if (this.userCardsRoleNum <= 0) {
        this.notRoleShowModal = true;
        this.lockBodyScroll();
        return;
      }
      if (this.total == 0) {
        this.notRoleShowModal = true;
        this.lockBodyScroll();
        return;
      }
      if (this.rolling) return;
      this.rolling = true;
      this.playSound('start');
      let count = 0;
      const speed = 60;
      const duration = 5000;
      const randomCardIndex = this.getRandomCard();
      const targetCard = this.cardList[randomCardIndex];
      const finalIndex = randomCardIndex;
      this.timer = setInterval(() => {
        this.activeIndex = count % this.cardList.length;
        count++;
        if (count * speed >= duration) {
          clearInterval(this.timer);
          this.activeIndex = finalIndex;
          this.rolling = false;
          this.gotCard = targetCard;
          this.showModal = true;
          this.lockBodyScroll();
          this.playSound('win');
          this.cardsUser.cardId = targetCard.id;
          this.saveCardsUser();
          this.getUserCardsRoleNum();
        }
      }, speed);
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    this.unlockBodyScroll();
  },
};
</script>
<style scoped>
/* Loading 遮罩弹窗 */
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}
.loading-box {
  background: #fff;
  padding: 25px 40px;
  border-radius: 12px;
  font-size: 16px;
  color: #333;
}
.gacha-container {
  max-width: 860px;
  margin: 50px auto;
  text-align: center;
  position: relative;
}
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  position: relative;
  z-index: 1999 !important;
}
.left-empty {
  flex: 1;
  text-align: left;
}
.right-empty {
  flex: 1;
  text-align: right;
}
.title {
  flex: 2;
  text-align: center;
  color: #fff;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.7);
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 3rem;
  font-weight: 700;
  font-family: "GenSenRoundedTW", "Helvetica", "Arial";
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.8);
}
.grid-box {
  display: grid;
  grid-template-columns: repeat(5, 155px);
  grid-template-rows: repeat(3, 220px);
  gap: 12px;
  justify-content: center;
}
/* ========== 卡片样式：无边框 + 黑色发光底 ========== */
.card-item {
  position: relative;
  background: #000;
  border: none;
  border-radius: 5px;
  padding: 0;
  overflow: hidden;
  transition: all 0.1s ease;
  box-shadow: 0 0 20px rgba(255,255,255,0.15);
}
.card-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}
.card-name,
.card-rate {
  position: relative;
  z-index: 2;
  color: #fff;
  text-shadow: 0 0 3px #000;
}
.card-name {
  font-size: 16px;
  font-weight: bold;
  margin-top: 15px;
}
.card-rate {
  font-size: 12px;
  color: #eee;
  margin-top: 4px;
}
.card-item.active {
  transform: scale(1.05);
  box-shadow: 0 0 40px 10px currentColor !important;
  border-color: #fff !important;
}
.rarity-1 {
  color: #fff;
}
.rarity-2 {
  color: #fff;
}
.rarity-3 {
  color: #fff;
}
.rarity-4 {
  color: #fff;
}
.rarity-5 {
  color: #fff;
}
.rarity-default {
  color: #fff;
}
.table-button {
  background: #fcc03a;
  box-shadow: 0px 0.5rem 0 #c28c00;
  border: none;
  border-radius: 2.75rem;
  font-size: 1.2rem;
  line-height: 2rem;
  padding: 0.5rem 2rem;
  color: white;
}
.table-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
/* ---------- 悬浮抽卡按钮 ---------- */
.float-lottery-wrapper {
  position: fixed;
  left: 50%;
  bottom: 8vh;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.chance-text {
  font-size: 14px;
  color: #fff;
  text-shadow: 0 1px 3px #000;
}
/* ---------- 无边框透明弹窗 ---------- */
.no-border-modal .modal-content {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  width: auto !important;
  border: none !important;
}
.no-border-img {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
}
/* 关闭X */
.close-x {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
}
.modal-content {
  text-align: center;
  background: #fff;
  padding: 20px;
  position: relative;
  width: 320px;
  max-width: 360px;
  border-radius: 24px;
}
/* 卡片發光外殼容器 */
.win-img-wrap {
  border-radius: 18px;
}
.win-img {
  display: block;
  width: 100%;
  border-radius: 14px;
  margin-bottom: 20px;
}
/* titleId對應外發光 shadow，和tag顏色對應 */
.glow-1 { box-shadow: 0 0 22px 6px #7dd3fc; }
.glow-2 { box-shadow: 0 0 22px 6px #a78bfa; }
.glow-3 { box-shadow: 0 0 22px 6px #facc15; }
.glow-4 { box-shadow: 0 0 22px 6px #fb923c; }
.glow-5 { box-shadow: 0 0 22px 6px #f472b6; }
.glow-6 { box-shadow: 0 0 22px 6px #34d399; }
.glow-7 { box-shadow: 0 0 22px 6px #f87171; }
.glow-8 { box-shadow: 0 0 22px 6px #22d3ee; }
.glow-9 { box-shadow: 0 0 22px 6px #c084fc; }
.glow-10 { box-shadow: 0 0 22px 6px #4ade80; }
.win-text {
  font-size: 20px;
  font-weight: bold;
  margin: 15px 0;
  color: #ff6600;
}
.win-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
}
.win-sub-title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  text-align: left;
}
.win-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  text-align: left;
  margin-bottom: 24px;
}
.confirm-btn {
  background: #ff7d00 !important;
  border-color: #ff7d00 !important;
  color: #fff !important;
  border-radius: 20px;
}
.card-tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  margin: 2px;
}
/*1:淺天藍 2:香芋紫 3:金黃 4:活力橙 5:蜜桃粉*/
/*6:薄荷綠 7:草莓紅 8:青湖藍 9:夢幻紫 10:嫩草綠*/
.tag-1 { background: #7dd3fc; }
.tag-2 { background: #a78bfa; }
.tag-3 { background: #facc15; }
.tag-4 { background: #fb923c; }
.tag-5 { background: #f472b6; }
.tag-6 { background: #34d399; }
.tag-7 { background: #f87171; }
.tag-8 { background: #22d3ee; }
.tag-9 { background: #c084fc; }
.tag-10 { background: #4ade80; }

/* ios safari 弹窗滚动穿透修复 */
:global(html.modal-open),
:global(body.modal-open) {
  overflow: hidden !important;
  height: 100% !important;
  position: fixed !important;
  width: 100%;
}
</style>
